import { Resource, SamlAlias } from "@impulse/sdp-shared-models";

import { ResourceViewWithAccessList, AccessListPartial } from "./models";

export function getResourceViewWithAccessList(
	policies: Resource[],
	aliases: SamlAlias[]
) {
	return policies.map<ResourceViewWithAccessList>((p) => {
		return Object.assign<Resource, AccessListPartial>(p, {
			accessList: p.access.users.concat(
				p.access.samlAliases.map((aliasId) => {
					const matchedAlias = aliases.find((a) => {
						return a.id === aliasId;
					});
					if (!!matchedAlias) {
						return matchedAlias.label;
					} else {
						// TODO what should we do if we don't find a match...??
						return "ERR";
					}
				})
			).sort((a, b) => {
				return a.localeCompare(b);
			})
		});
	});
}
